import axios from 'axios'

const base_CSR_API_URL = 'https://data.exiledracers.com/api/v1/';

export const axiosInstance = axios.create({
    baseURL: base_CSR_API_URL,
    timeout: 60000,
    headers: {
        'Content-Type': 'application/json',
        'accept': 'application/json',
    }
});